import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/App';

if (window.location.pathname.endsWith('/index.html')) {
  const newPath = window.location.pathname.replace(/\/index\.html$/, '/');
  window.history.replaceState({}, '', newPath + window.location.search + window.location.hash);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
